import { get } from './fetchUtils';
const paramValues = {
  bodyStyleCodes: 'bodyStyleCode',
  bodyStyleSubtypeCodes: 'bodyStyleSubtypeCode',
  seriesCodeList: 'classSeriesCode',
  classSeriesTrim: 'classSeriesTrim',
  doorCodes: 'doorCode',
  driveGroup: 'driveGroup',
  engineCodes: 'engineGroup',
  extColorsSimple: 'extColorGroup',
  featureCodes: 'featureCode',
  fuelTypeGroup: 'fuelTypeGroup',
  interiorColorsSimple: 'intColorGroup',
  keywordPhrases: 'keywordPhrase',
  listingTypes: 'listingType',
  makeCodeList: 'makeCode',
  modelCodeList: 'modelCode',
  trimCodeList: 'modelTrim',
  mpgRanges: 'mpgRanges',
  sellerTypes: 'sellerTypes',
  transmissionCodes: 'transmission',
  premiumFeatureCodes: 'premiumFeatureCode',
  vehicleStyleCodes: 'bodyStyleCode',
  maxMileage: 'mileage'
};
const transformedKeys = Object.keys(paramValues);
function transformSearch(criteria) {
  const transformedSearch = {};
  Object.keys(criteria).forEach(key => {
    if (transformedKeys.includes(key)) {
      transformedSearch[paramValues[key]] = criteria[key].split(',');
    } else {
      transformedSearch[key] = criteria[key];
    }
  });
  return transformedSearch;
}

/**
 * Handles storing and caching personalization remotely
 * @module PersonalizationInventory
 */
export default class PersonalizationInventory {
  constructor(config) {
    if (config === void 0) {
      config = {};
    }
    this.rootPath = config.personalizationInventoryApiPath;
    this.inventoryApiPath = config.inventoryApiPath;
  }

  /**
   * Get fully qualified path to personalization inventory api
   * @alias PersonalizationInventory
   * @param  {String} method name
   * @return {String} path
   */
  getApiPath(method) {
    return this.rootPath + method;
  }

  /**
   * Get fully qualified path to inventory api api
   * @alias PersonalizationInventory
   * @param  {String} method name
   * @return {String} path
   */
  getInventoryApiPath(method) {
    return this.inventoryApiPath + method;
  }

  /**
   * returns get listings
   * @alias PersonalizationInventory
   * @return {Object}
   */
  async getRecentlySearchedInventory(criteria) {
    if (criteria === void 0) {
      criteria = {};
    }
    return get(this.getApiPath('recentsearches/listings'), transformSearch(criteria));
  }

  /**
   * returns get listings
   * @alias PersonalizationInventory
   * @return {Object}
   */
  async getInventoryCounts(criteria) {
    if (criteria === void 0) {
      criteria = {};
    }
    // TODO: this endpoint should really move to /rest/pl/v0/
    return get(this.getInventoryApiPath('recentsearches/counts'), criteria);
  }
}